
<ui-detail-view-container>
    <ui-detail-section>
        <ui-detail-image
            [imagePath]="facility().imagePath"
            [altText]="facility().title"
        />

        <ui-detail-title [title]="facility().title"/>

        <ui-detail-address [text]="facility().address"/>

        <ui-detail-tags
            [tags]="['Kulturinstitution oder -location']"
        />
    </ui-detail-section>

    @if (facility().shortDescription; as shortDescription) {
        <ui-detail-description
            [title]="'Standortbezeichnung'"
            [htmlDescription]="shortDescription"
        />
    }

    <ui-detail-section>
        @if (facility().phone; as phone) {
            <ui-detail-phone-link
                [title]="'Telefon'"
                [phone]="phone"
            />
        }

        @if (facility().email; as email) {
            <ui-detail-email-link
                [title]="'E-Mail'"
                [email]="email"
            />
        }

        @if (facility().fax; as fax) {
            <ui-detail-phone-link
                [title]="'Fax'"
                [phone]="fax"
            />
        }

        @if (facility().weblink; as weblink) {
            <ui-detail-weblink
                [title]="'Website'"
                [link]="weblink"
            />
        }
    </ui-detail-section>

    @if (facility().linkedItems?.length) {
        <ui-detail-table
            titleLeft="Kulturinstitution oder -location"
        >
            @for (linkedItem of facility().linkedItems; track linkedItem.id) {
                <ui-detail-table-row>
                    <ui-detail-link left
                        [label]="linkedItem.title"
                        (mapItemLinkClicked)="triggerMapItemById(linkedItem)"
                    />
                </ui-detail-table-row>
            }
        </ui-detail-table>
    }
</ui-detail-view-container>
